import { render } from "./Card.vue?vue&type=template&id=253762ec&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=253762ec&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\Сurrent_Projects\\inter-qr\\web-updates\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253762ec"]])

export default __exports__